import {Component, Input} from '@angular/core';
import {UntilDestroy} from '@ngneat/until-destroy';
import {Lottery} from '~core/models';
import {TooltipTranslationService} from '~shared/translations/tooltip-translations.service';
import {EventAdministrationService} from "~features/tixx-select/event-administration.service";

/**
 * Displays webpage individualization information
 */
@UntilDestroy()
@Component({
  selector: 'app-webpage-individualization-info',
  templateUrl: './webpage-individualization-info.component.html',
})
export class WebpageIndividualizationInfoComponent {
  @Input() public selectedLottery: Lottery;

  constructor(
    public tooltipTranslations: TooltipTranslationService,
    public tixxSelectOverviewService: EventAdministrationService,
  ) {
  }

  /**
   * Opens the edit webpage individualization sidebar
   */
  public editWebpageIndividualization(): void {
    this.tixxSelectOverviewService.toggleAllModal(false);
    this.tixxSelectOverviewService.toggleEditWebpageIndividualizationModal(true);
  }

  get hasAnyContent(): boolean {
    const event = this.selectedLottery.event;
    if (event.heroImage) {
      return true;
    } else if (event.guidelineHeadline) {
      return true;
    } else if (event.guidelineText) {
      return true;
    }
    return false;
  }

}
